import session from "./../session";

export default {

  fetchCplLeads(filters) {
    const added = typeof filters.added === 'object' ? filters.added : [filters.added];
    const sold = typeof filters.sold === 'object' ? filters.sold : [filters.sold];
    
    return session.get(`/leads/?product_links=true&kind__in=${filters.kind.join(',')}&source__in=${filters.source.join(',')}&status__in=${filters.status.join(',')}&added__gte=${added?added[0]:''}&added__lte=${added&&added[1]?added[1]:''}&sold__gte=${sold?sold[0]:''}&sold__lte=${sold&&sold[1]?sold[1]:''}&cpl=${filters.hideCompleted?'null':''}`);
  },

  async setCPL(data) {

    const cplApis = await Promise.all(data.leads.map(async lead=>{
      try{
        await session.patch(`/leads/${lead}/`,{cpl:data.cpl});
        return { success: true, lead_id: lead };
      }
      catch(error){
        const errorMessage = error.response.status === 400 ? error.response.data.message.cpl[0] : error.response.data.message;
        return { success: false, lead_id: lead, message: errorMessage};
      }
    }));

    return cplApis;
  },

  fetchStatusFilters() {
    return session.get(`/static-data/options/?object_kind=Lead&field=status`);
  },

  fetchSourceFilters(filters) {
    const added = typeof filters.added === 'object' ? filters.added : [filters.added];
    const sold = typeof filters.sold === 'object' ? filters.sold : [filters.sold];
    return session.get(`/leads/sources/?kind__in=${filters.kind.join(',')}&status__in=${filters.status.join(',')}&added__gte=${added?added[0]:''}&added__lte=${added&&added[1]?added[1]:''}&sold__gte=${sold?sold[0]:''}&sold__lte=${sold&&sold[1]?sold[1]:''}`);
  },

};
